"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var ReservationInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ReservationInit, _super);
    function ReservationInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品预约初始化接口';
        _this.code = '101042';
        _this.desc = '理财产品预约初始化接口';
        _this.requestParams = new product_1.ReservationInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ReservationInit;
}(service_1.BaseService));
exports.ReservationInit = ReservationInit;
//# sourceMappingURL=reservationInit.js.map